import { getStaticAssetsBaseUrl } from '@/helpers/Url/Url';
import { useLocalLandingStore } from '@/stores/localLanding/localLanding';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

export function useHeroImageUrl() {
  const localLandingStore = useLocalLandingStore();
  const { routeLocation } = storeToRefs(localLandingStore);

  const heroImageUrl = computed<string>(
    () =>
      `${getStaticAssetsBaseUrl()}images/localLanding/${routeLocation.value}/preload-hero-image.webp`,
  );

  return {
    heroImageUrl,
  };
}
